<template>
  <div class="flex items-center justify-center h-screen bg-opacity-50" >
    <LoadingSpinner text="Loading..."/>
  </div>
</template>